// Copyright 2022, Imprivata, Inc.  All rights reserved.

import type { CodingContext } from '@imprivata-cloud/data-privacy-js';
import { createContext } from 'react';
import featureFlags from '../../featureFlags.json';

export type FeatureFlags = typeof featureFlags.dev;

export const PlatformContext = createContext<{
  codingContext: CodingContext | undefined;
  featureFlags: FeatureFlags;
}>({ codingContext: undefined, featureFlags: featureFlags.dev });
